var cookie_notice = ( function( $ ) {

	var $notice = false;
	var $html = false;

	var _init = function() {
		$notice = $( '#cookie-notice' );
		$html = $( 'html' );

		_setup();
	};

	var _setup = function() {
		if ( ! is_accepted() ) {
			$notice.find( '.accept' ).on( 'click', _accept_click_event );

			open();
		}
	};

	var _accept_click_event = function( e ) {
		e.preventDefault();

		accept();
		close();
	};

	var accept = function() {
		$.cookie( 'cookies_accepted', 'true', { expires: 365 } );
	};

	var is_accepted = function() {
		return $.cookie( 'cookies_accepted' );
	};

	var open = function() {
		$html.addClass( 'cookie-bar-active' );
	};

	var close = function() {
		$html.removeClass( 'cookie-bar-active' );
	};

	$( document ).ready( _init );

	return {
		accept : accept,
		is_accepted : is_accepted,
		open : open,
		close : close
	};

} )( jQuery );

module.exports = cookie_notice;